export const isValidImageSrc = (src?: string) => {
  if (!src) return false;
  return src.startsWith('/') || src.startsWith('http') || src.startsWith('data:');
};
